import React from 'react'
import PropTypes from 'prop-types'
import { Table, Button, Form, Modal, Tabs } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

import styled from 'styled-components'
import NotificationForm from './NotificationForm'
import { toast } from 'react-toastify'
import SendNotificationForm from './SendNotificationForm'
import DispatchHistory from './DispatchHistory'

const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const Notifications = ({
  notifications,
  addNotificationHandler,
  editNotificationHandler,
  deleteNotificationHandler
}) => {
  const [form] = Form.useForm()
  const [formForEdit] = Form.useForm()
  const [modalVisible, setModalVisible] = React.useState(false)
  const [notificationItem, setNotificationItem] = React.useState(null)
  const [sendModal, setSendModal] = React.useState(false)
  const [editModal, setEditModal] = React.useState(false)
  const [deleteModal, setDeleteModal] = React.useState(false)

  const columns = [
    {
      title: 'Заголовок (каз)',
      dataIndex: 'headingKZ'
    },
    {
      title: 'Заголовок (рус)',
      dataIndex: 'headingRU'
    },
    {
      title: 'Заголовок (англ)',
      dataIndex: 'headingEN'
    },
    {
      title: 'Описание (каз)',
      dataIndex: 'messageKZ'
    },
    {
      title: 'Описание (рус)',
      dataIndex: 'messageRU'
    },
    {
      title: 'Описание (англ)',
      dataIndex: 'messageEN'
    },
    {
      title: 'Действие',
      width: '20%',
      render: item => (
        <>
          <span>
            <Button onClick={() => setNotificationItem(item)}>
              Выбрать это уведомление
            </Button>
            <Button
              type="link"
              onClick={() => {
                formForEdit.resetFields()
                setEditModal(true)
                setNotificationItem(item)
              }}
            >
              Редактировать
            </Button>
            <Button
              danger
              type="link"
              onClick={() => {
                setDeleteModal(true)
                setNotificationItem(item)
              }}
            >
              Удалить
            </Button>
          </span>
        </>
      )
    }
  ]

  return (
    <>
      <Tabs defaultActiveKey="templates">
        <Tabs.TabPane tab="Шаблоны" key="templates">
          <Table
            dataSource={notifications}
            columns={columns}
            rowKey={item => item.id}
            title={() => (
              <StyledHeaderContainer>
                <Button type="primary" onClick={() => setModalVisible(true)}>
                  <PlusOutlined /> Новое уведомление
                </Button>
                <Button
                  type="default"
                  onClick={() => {
                    if (!notificationItem)
                      return toast.error('Выберите уведомление')
                    setSendModal(true)
                  }}
                >
                  <PlusOutlined /> Отправить уведомление
                </Button>
                <div>
                  Выбранное уведомление:{' '}
                  {notificationItem?.messageRU || 'Не выбрано'}
                </div>
              </StyledHeaderContainer>
            )}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="История отправок" key="history">
          <DispatchHistory />
        </Tabs.TabPane>
      </Tabs>
      <Modal
        open={modalVisible}
        destroyOnClose
        title="Новое уведомление"
        okText="Создать"
        cancelText="Отмена"
        onCancel={() => {
          form.resetFields()
          setModalVisible(false)
        }}
        onOk={() => {
          addNotificationHandler(form, setModalVisible)
        }}
      >
        <NotificationForm form={form} />
      </Modal>
      <Modal
        open={sendModal}
        destroyOnClose
        title="Отправить уведомление"
        onCancel={() => {
          setSendModal(false)
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setSendModal(false)
            }}
          >
            Закрыть
          </Button>
        ]}
      >
        <SendNotificationForm
          notificationId={notificationItem?.id}
          onSent={() => setSendModal(false)}
        />
      </Modal>
      <Modal
        open={editModal}
        destroyOnClose
        onCancel={() => {
          setEditModal(false)
        }}
        onOk={() => {
          editNotificationHandler(
            formForEdit,
            notificationItem.id,
            setEditModal
          )
        }}
      >
        <NotificationForm form={formForEdit} {...notificationItem} />
      </Modal>
      <Modal
        open={deleteModal}
        onCancel={() => {
          setDeleteModal(false)
        }}
        onOk={() =>
          deleteNotificationHandler(notificationItem.id, setDeleteModal)
        }
      >
        <h3>
          Вы действительно хотите удалить '{notificationItem?.headingRU}' ?
        </h3>
      </Modal>
    </>
  )
}

Notifications.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.object).isRequired,
  addNotificationHandler: PropTypes.func.isRequired,
  editNotificationHandler: PropTypes.func.isRequired,
  deleteNotificationHandler: PropTypes.func.isRequired
}

export default Notifications
